module.exports = __webpack_public_path__ + "static/media/scrapbookiconhover.cf0b7880.svg";